/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { DatePipe, DecimalPipe } from '@angular/common';
import { TableColumns } from '../models/table-columns';

declare const zipcelx;

export interface XlsxExportConfiguration {
	translate: (key: string) => string;
	datePipe: DatePipe;
	formatPipe: DecimalPipe;
	locale: string;
}

export function xlsExport(
	data: any[],
	columns: TableColumns<never>,
	fileName = '',
	configurations?: XlsxExportConfiguration
): void {
	const result = prepareExcelData(data, columns, configurations);
	const currentDate = new Date();
	const config = {
		filename: `${fileName} excel export ${currentDate.getFullYear()}-${
			currentDate.getMonth() + 1
		}-${currentDate.getDate()}`,
		sheet: {
			data: result,
		},
	};
	zipcelx(config);
}

function prepareExcelData(data: any[], columns: TableColumns<never>, configurations?: XlsxExportConfiguration) {
	const result = [];

	const headers = columns.map((item) => ({
		value: item.header,
		type: 'string',
	}));

	result.push(headers);

	data.forEach((item) => {
		const cell = [];
		for (const col of columns) {
			const value = item[col.field];
			if (value === null || value === undefined) {
				cell.push({
					value: '',
					type: 'string',
				});
			} else {
				switch (col.type) {
					case 'number':
						cell.push({
							value: configurations.formatPipe.transform(value ?? 0, col.numberFormat, configurations.locale),
							type: 'string',
						});
						break;
					case 'date':
						cell.push({
							value: String(configurations.datePipe.transform(value, col.dateFormat, configurations.locale)),
							type: 'string',
						});
						break;
					case 'valid':
						cell.push({
							value: String(configurations.translate('table.valid.' + value)),
							type: 'string',
						});
						break;
					case 'status':
						cell.push({
							value: String(
								configurations.translate((col.prefix ? col.prefix + '.' : '') + value.toString().toLowerCase())
							),
							type: 'string',
						});
						break;
					case 'text': {
						if (col.translate) {
							cell.push({
								value: col.prefix
									? configurations.translate(col.prefix + '.' + String(value).toLowerCase())
									: configurations.translate(String(value).toLowerCase()),

								type: 'string',
							});
						} else {
							cell.push({
								value: String(value),
								type: 'string',
							});
						}
						break;
					}
					default: {
						cell.push({
							value: String(value),
							type: 'string',
						});
						break;
					}
				}
			}
		}
		result.push(cell);
	});
	return result;
}

export function xlsExportWithData(data: any, fileName = 'excel-export'): void {
	const config = {
		filename: fileName,
		sheet: {
			data: data,
		},
	};
	zipcelx(config);
}
